import React, { Component } from 'react';
import ReactSwipe from 'react-swipe';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { ReactSwipeDots } from './ReactSwipeDots';
import { Container } from '../styles/Container';
import MainProductImage from './MainProductImage';
import { SITE_ROOT_URL } from '../constants/endpoints';

import { size } from '../styles/helpers/variables';
import { ProductImageBackground } from '../styles/ProductImageBackground';
import { ProductImage } from '../styles/ProductImage';
import { ProductTag } from '../styles/ProductTag';
import { MATERIAL_IMAGE } from "../constants/imageTypes";

class SwipeWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      swipeIndex: 0,
      allImages: []
    };
    this.onSwipeChangeCallback = this.onSwipeChangeCallback.bind(this);
    this.getAllImages = this.getAllImages.bind(this);
  }

  componentDidMount() {
    this.getAllImages(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.getAllImages(nextProps);
  }

  onSwipeChangeCallback(index) {
    this.setState({
      swipeIndex: index
    });
  }

  getAllImages(props) {
    const productImages =
      props.currentProduct.get('images') &&
      props.currentProduct
        .get('images')
        .skip(1)
        .toArray();

    const variantImages =
      props.selectedVariant.get('images') &&
      props.selectedVariant
        .get('images')
        .skip(props.productImageType === MATERIAL_IMAGE ? 0 : 1)
        .toArray();

    const allImages = [...(variantImages || []), ...(productImages || [])];

    this.setState({ allImages })
  }

  jumpToFirst() {
    if (this.reactSwipe) {
      this.reactSwipe.slide(0);
    }
  }

  render() {
    const {
      pageWidth,
      productImageUrl,
      productImageAlt,
      productImageType,
      baseProductImageUrl,
      baseProductImageAlt,
    } = this.props;
    const { allImages } = this.state;

    const productImagesInSwipe = allImages.map((image, index) => (
      <Container swipe noPadding pageWidth={pageWidth} key={index}>
        <ProductImageBackground backGroundImg={SITE_ROOT_URL + encodeURI(image.get('url'))} />
      </Container>
    ));

    const reactSwipeDots =
      allImages.length !== 0 ? (
        <ReactSwipeDots swipeIndex={this.state.swipeIndex} numberOfDots={allImages.length + 1} />
      ) : (
        ''
      );

    return (
      <SwipeContainer className="SwipeContainer">
        <ReactSwipe
          className="carousel"
          ref={reactSwipe => {
            this.reactSwipe = reactSwipe;
          }}
          childCount={allImages.length + 1}
          swipeOptions={{ continuous: false, callback: this.onSwipeChangeCallback }}
        >
          <Container swipe noPadding pageWidth={pageWidth} key={8}>
            <MainProductImage className="mainProductImage" swipe={allImages.length !== 0}>
              <ProductTagContainer>
                {this.props.selectedVariant.get('tags', List()).map(tag => (
                  <ProductTag color={tag.get('key')}>{tag.get('value')}</ProductTag>
                ))}
              </ProductTagContainer>
              { productImageType === MATERIAL_IMAGE ?
                <ProductImage src={baseProductImageUrl} alt={baseProductImageAlt} />
                :
                <ProductImage src={productImageUrl} alt={productImageAlt} />
              }
            </MainProductImage>
          </Container>
          {productImagesInSwipe}
        </ReactSwipe>
        {reactSwipeDots}
      </SwipeContainer>
    );
  }
}
const ProductTagContainer = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  top: 10px;
  left: 8px;
  @media screen and (min-width: ${size.medium}px) {
    top: 11px;
    left: 11px;
  }
`;

const SwipeContainer = styled.div`
  display: block;
`;

SwipeWrapper.defaultProps = {
  currentProduct: Map(),
  selectedVariant: Map(),
  pageWidth: 0,
  productImageUrl: null,
  productImageAlt: '',
  baseProductImageUrl: null,
  baseProductImageAlt: '',
};

SwipeWrapper.propTypes = {
  currentProduct: PropTypes.instanceOf(Map),
  selectedVariant: PropTypes.instanceOf(Map),
  pageWidth: PropTypes.number,
  productImageUrl: PropTypes.string,
  productImageAlt: PropTypes.string,
  baseProductImageUrl: PropTypes.string,
  baseProductImageAlt: PropTypes.string,
};

export default SwipeWrapper;



// WEBPACK FOOTER //
// ./src/components/SwipeWrapper.js